var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keyWordReportList"},[_c('data-list',{attrs:{"data":_vm.data,"columns":_vm.column,"tableStyle":{ name: 'mixture' },"page":_vm.page,"page-size":_vm.page.pageSize,"loading":_vm.loading},on:{"page-size-changed":_vm.pageSizeChanged,"page-changed":_vm.pageChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }